module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "also-by-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Also by Valerie Keogh")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("The Dublin Murder Mysteries")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://mybook.to/NoSimpleDeath",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("No Simple Death")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://mybook.to/NoObviousCause",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("No Obvious Cause")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://mybook.to/NoPastForgiven",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("No Past Forgiven")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://mybook.to/NoMemoryLost",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("No Memory Lost")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Psychological thrillers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://mybook.to/TheThreeWomen",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("The Three Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_c('i', [_vm._v("The Perfect Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_c('i', [_vm._v("The Deadly Truth")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da69466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/also-by-valerie-keogh.vue
// module id = 72
// module chunks = 0